import React, { useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthConext } from '../../context/AuthProvider';
import logo from '../../assets/images/favicon.ico'

const Header = () => {
    const navigate = useNavigate()
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { user, logOut } = useContext(AuthConext);
    console.log(user)

    const handleLogOut = () => [
        logOut()
            .then(() => { 
                navigate('/')
            })
            .then((error) => {
                console.log(error)
            })
    ]


    const menuItems = <>
        <li><NavLink to='/home' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Home</NavLink></li>
        <li><NavLink to='/blog' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Blog</NavLink></li>
        {
            user ?
                <>
                    <li><NavLink to='/AddService' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Add Services</NavLink></li>
                    <li><NavLink to='/myReviews' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">My Reviews</NavLink></li>
                    <li onClick={handleLogOut}><NavLink className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Log out</NavLink></li>
                    <li onClick={handleLogOut} className="flex justify-center font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">
                        {
                            user
                                ?
                                <img src={user?.photoURL} alt="" className='w-12 h-12 rounded-full ring-2 ring-offset-4 dark:bg-gray-500 ring-orange-600 ring-offset-gray-800' />
                                :
                                <button className='text-white'>No user</button>
                        }
                    </li>
                </>
                :
                <>
                    <li><NavLink to='/login' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Login</NavLink></li>
                    <li><NavLink to='/register' className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400">Register</NavLink></li>
                </>
        }
    </>




    return (
        <div className="primary-bg-color" style={{ position: "sticky", top: "0", zIndex: "9999", left: "0", width: "100%" }}>
            <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
                <div className="relative flex items-center justify-between">
                    <a
                        href="/"
                        aria-label="Company"
                        title="Company"
                        className="inline-flex items-center"
                    >
                        <img src={logo} alt="logo" className='w-16 h-16 rounded-full' />
                        <span className="ml-2 text-xl font-bold tracking-wide text-gray-100 uppercase">
                            YUMMY KITCHEN
                        </span>
                    </a>
                    <ul className="flex items-center hidden space-x-8 lg:flex">
                        {menuItems}
                    </ul>
                    <div className="lg:hidden">
                        <button
                            aria-label="Open Menu"
                            title="Open Menu"
                            className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
                            onClick={() => setIsMenuOpen(true)}
                        >
                            <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                                />
                                <path
                                    fill="currentColor"
                                    d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                                />
                                <path
                                    fill="currentColor"
                                    d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                                />
                            </svg>
                        </button>
                        {isMenuOpen && (
                            <div className="absolute top-0 left-0 w-full">
                                <div className="p-5 primary-bg-color border rounded shadow-sm">
                                    <div className="flex items-center justify-between mb-4">
                                        <div>
                                            <a
                                                href="/"
                                                aria-label="Company"
                                                title="Company"
                                                className="inline-flex items-center"
                                            >
                                                <img src={logo} alt="logo" className='w-16 h-16 rounded-full' />
                                                <span className="ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase">
                                                    YUMMY KITCHEN
                                                </span>
                                            </a>
                                        </div>
                                        <div>
                                            <button
                                                aria-label="Close Menu"
                                                title="Close Menu"
                                                className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                                    <path
                                                        fill="currentColor"
                                                        d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <nav>
                                        <ul className="space-y-4">
                                            {menuItems}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;